import PropTypes from "prop-types";
import { IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: "100%",
    border: "1px solid rgba(0,0,0)",
    borderRadius: "0 15px 15px 0",
  },
  header: {
    borderBottomWidth: "1px",
    borderBottomColor: "inherit",
    borderBottomStyle: "solid",
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 2),
  },
  headerContent: {
    flex: 1,
  },
  body: {
    padding: theme.spacing(0, 2),
  },
}));

function Message({ header, body, onClose, className = "" }) {
  const classes = useStyles();

  return (
    <div className={clsx(classes.wrapper, className)}>
      <div className={classes.header}>
        <div className={classes.headerContent}>{header}</div>
        <IconButton aria-label="close" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <div className={classes.body}>{body}</div>
    </div>
  );
}

Message.propTypes = {
  header: PropTypes.element.isRequired,
  body: PropTypes.any.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default Message;
